import { useRouter } from 'next/router';
import EcoTextTc from 'eco-design/sections/eco-text-tc';
import { termsMap } from '../../../../config/terms';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function Comp() {
    const { locale } = useRouter();
    const termsData = termsMap[locale as keyof typeof termsMap] || termsMap.eu;
    const { t } = useLang('theProduct.FooterTcA');

    const items = [
        {
            isHead: true,
            title: t('head1'),
        },
        {
            title: t('titleA1'),
        },
        {
            title: t('titleA1'),
        },
        {
            isHead: true,
            title: t('head1'),
        },
        {
            title: t('titleA1'),
            desc: t('descA1'),
        },
    ];

    return (
        <>
            <EcoTextTc items={termsData} className={styles.comp} />
        </>
    );
}
